export const REQUIRED_FIELD_MSG = (label: string = 'Field') => `${label} is required`;
export const MINIMUM_CHARACTERS_MSG = (count: number = 2) => `At least ${count} characters`;
export const MAXIMUM_CHARACTERS_MSG = (count: number = 20) => `Maximum ${count} characters`;
export const INVALID_PHONE_MSG = 'Invalid phone number';
export const WRONG_EMAIL_MSG = 'Wrong email address';
export const SOMETHING_WRONG_MSG = 'Something went wrong';
